import { render, staticRenderFns } from "./WholesaleForm.vue?vue&type=template&id=323ec65e&lang=pug&"
import script from "./WholesaleForm.vue?vue&type=script&lang=js&"
export * from "./WholesaleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports